/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Handoff_Desc7Inputs */

const en_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuck calls transfer to a human with full context. Transcripts, recordings and dashboards show what callers want.`)
};

const ar_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المكالمات المتعثرة تحول إلى إنسان مع كامل السياق. النصوص والتسجيلات ولوحات المتابعة تظهر ما يريده المتصلون.`)
};

const bn_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আটকে যাওয়া কল পুরো প্রসঙ্গসহ মানুষের কাছে যায়। ট্রান্সক্রিপ্ট, রেকর্ডিং আর ড্যাশবোর্ড দেখায় কলাররা কী চায়।`)
};

const de_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festgefahrene Anrufe werden mit vollem Kontext an einen Menschen übergeben. Transkripte, Aufzeichnungen und Dashboards zeigen, was Anrufer wollen.`)
};

const es_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las llamadas complicadas pasan a un humano con todo el contexto. Transcripciones, grabaciones y paneles muestran lo que quieren quienes llaman.`)
};

const fr_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les appels bloqués sont transférés à un humain avec tout le contexte. Transcriptions, enregistrements et tableaux de bord montrent ce que veulent les appelants.`)
};

const pt_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamadas travadas passam a um humano com todo o contexto. Transcrições, gravações e painéis mostram o que os clientes querem.`)
};

const zh_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卡住的通话带着完整上下文转给人工。文字记录、录音和看板展示来电者的真实需求。`)
};

const tr_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takılan çağrılar tüm bağlamla bir insana devredilir. Transkriptler, kayıtlar ve panolar arayanların ne istediğini gösterir.`)
};

const ru_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застрявшие звонки передаются человеку со всем контекстом. Транскрипты, записи и дашборды показывают, чего хотят звонящие.`)
};

const pl_svc_ai_voice_agents_handoff_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zablokowane rozmowy przekazywane człowiekowi z pełnym kontekstem. Transkrypty, nagrania i dashboardy pokazują, czego chcą dzwoniący.`)
};

/**
* | output |
* | --- |
* | "Stuck calls transfer to a human with full context. Transcripts, recordings and dashboards show what callers want." |
*
* @param {Svc_Ai_Voice_Agents_Handoff_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_handoff_desc7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Handoff_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Handoff_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_handoff_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_handoff_desc7(inputs)
	return en_svc_ai_voice_agents_handoff_desc7(inputs)
});
export { svc_ai_voice_agents_handoff_desc7 as "svc_ai-voice-agents_HANDOFF_desc" }